import React from "react";
import withAuthorization from "../../hoc/withAuthorization";
import useFetch from "@/hoc/useFetch";
import AdminPin from "@/components/Settings/Sections/AdminPin";
import ModalWindow from "@/custom_components/ModalWindow";
import { getActiveShop } from "@/constants/utility";

const AdminCode = ({ user, httpClient }) => {
  const { data, loading, status, setData } = useFetch({
    httpClient,
    url: "/account/employee-code-set/" + user._id,
  });
  const selectedShop = getActiveShop(user);

  return status == "complete" &&
    !loading &&
    !data?.employeeCode &&
    !/free/i.test(selectedShop?.plan) ? (
    <ModalWindow className="uk-background-muted uk-width-medium">
      <div className="uk-card-default uk-card-body">
        <AdminPin close={() => setData({ employeeCode: true })} />
      </div>
    </ModalWindow>
  ) : null;
};

const condition = (authUser) => {
  return authUser.selectedShop && authUser.email;
};

export default withAuthorization(condition)(AdminCode);
